import React from 'react';
import PaginationComponent from "../../../component/table/Pagination";

const FormListTable = ({ formList, total, page, size, onPageChange, onDelete }) => {

    const formatDate = (dateString) => {
        if (!dateString) return '-';

        // Date 객체인 경우
        if (dateString instanceof Date) {
            return dateString.toISOString().split('T')[0];
        }

        // 배열인 경우 ([2024, 2, 3, 10, 30, 45] 형식)
        if (Array.isArray(dateString)) {
            const [year, month, day] = dateString;
            return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        }

        // 문자열인 경우
        if (typeof dateString === 'string') {
            // "2024-02-03 10:30:45" 형식
            if (dateString.includes(' ')) {
                return dateString.split(' ')[0];
            }
            // "2024-02-03T10:30:45" 형식
            if (dateString.includes('T')) {
                return dateString.split('T')[0];
            }
            return dateString;
        }

        return '-';
    };

    return (
        <>
            <div className="table-responsive">
                <table className="table table-hover align-middle">
                    <thead className="table-light">
                        <tr>
                            <th className="text-center d-none d-md-table-cell" style={{ width: '50px' }}>No</th>
                            <th>폼 제목</th>
                            <th className="text-center" style={{ width: '100px' }}>응답 수</th>
                            <th className="text-center d-none d-md-table-cell" style={{ width: '120px' }}>생성일</th>
                            <th className="text-center" style={{ width: '260px' }}>관리</th>
                        </tr>
                    </thead>
                    <tbody>
                        {formList && formList.length > 0 ? (
                            formList.map((item, index) => {
                                const itemNo = (page - 1) * size + (index + 1);
                                return (
                                    <tr key={item.uid}>
                                        <td className="text-center d-none d-md-table-cell">{itemNo}</td>
                                        <td>
                                            <div className="d-flex flex-column">
                                                <span className="fw-semibold text-break">{item.formTitle}</span>
                                                <small className="text-muted d-none d-md-inline">{item.templateName}</small>

                                                {/* 모바일 전용 메타 정보 */}
                                                <div className="d-md-none mt-1 text-muted" style={{ fontSize: '0.75rem' }}>
                                                    <div className="d-flex gap-2 align-items-center">
                                                        <span>{formatDate(item.createdAt)}</span>
                                                        <span className="text-secondary">
                                                            응답 <b className="text-dark">{item.answerCount || 0}</b>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="text-center">
                                            <span className="fw-bold text-dark" style={{ fontSize: '1rem' }}>
                                                {item.answerCount || 0}
                                            </span>
                                        </td>
                                        <td className="text-center d-none d-md-table-cell">
                                            <small className="text-muted">{formatDate(item.createdAt)}</small>
                                        </td>
                                        <td>
                                            <div className="d-flex gap-2 justify-content-center">
                                                <a
                                                    href={item.formUrl}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn btn-sm btn-primary d-flex align-items-center gap-1 text-nowrap"
                                                    style={{ minWidth: '80px' }}
                                                >
                                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                                                        <polyline points="15 3 21 3 21 9"></polyline>
                                                        <line x1="10" y1="14" x2="21" y2="3"></line>
                                                    </svg>
                                                    폼 열기
                                                </a>
                                                
                                                {item.googleFormId && (
                                                    <a
                                                        href={`https://docs.google.com/forms/d/${item.googleFormId}/edit#responses`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="btn btn-sm btn-outline-primary d-flex align-items-center gap-1 text-nowrap"
                                                        style={{ minWidth: '80px' }}
                                                    >
                                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                                            <polyline points="14 2 14 8 20 8"></polyline>
                                                            <line x1="16" y1="13" x2="8" y2="13"></line>
                                                            <line x1="16" y1="17" x2="8" y2="17"></line>
                                                            <polyline points="10 9 9 9 8 9"></polyline>
                                                        </svg>
                                                        응답 확인
                                                    </a>
                                                )}
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-danger d-flex align-items-center gap-1 text-nowrap"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        onDelete(item.uid);
                                                    }}
                                                    style={{ minWidth: '70px' }}
                                                >
                                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <polyline points="3 6 5 6 21 6"></polyline>
                                                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                                        <line x1="10" y1="11" x2="10" y2="17"></line>
                                                        <line x1="14" y1="11" x2="14" y2="17"></line>
                                                    </svg>
                                                    삭제
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan="5" className="text-center py-5 text-muted">
                                    생성된 폼이 없습니다.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <PaginationComponent
                page={page}
                total={total}
                sizePerPage={size}
                handleChange={onPageChange}
            />
        </>
    );
};

export default FormListTable;
